var _path, _path2, _path3;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgWarning(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 128,
    height: 128,
    viewBox: "0 0 128 128",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M54.8801 20.5878L9.70678 96.0011C8.77541 97.614 8.2826 99.4427 8.27739 101.305C8.27217 103.168 8.75473 104.999 9.67705 106.617C10.5994 108.235 11.9293 109.584 13.5346 110.528C15.1398 111.473 16.9644 111.981 18.8268 112.001H109.173C111.036 111.981 112.86 111.473 114.466 110.528C116.071 109.584 117.401 108.235 118.323 106.617C119.245 104.999 119.728 103.168 119.723 101.305C119.718 99.4427 119.225 97.614 118.293 96.0011L73.1201 20.5878C72.1693 19.0203 70.8306 17.7244 69.2332 16.825C67.6357 15.9256 65.8334 15.4531 64.0001 15.4531C62.1669 15.4531 60.3645 15.9256 58.7671 16.825C57.1696 17.7244 55.8309 19.0203 54.8801 20.5878V20.5878Z",
    stroke: "#B30200",
    strokeWidth: 5,
    strokeLinecap: "round",
    strokeLinejoin: "bevel"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M64 48V69.3333",
    stroke: "#B30200",
    strokeWidth: 5,
    strokeLinecap: "round",
    strokeLinejoin: "bevel"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M64 90.668H64.0533",
    stroke: "#B30200",
    strokeWidth: 5,
    strokeLinecap: "round",
    strokeLinejoin: "bevel"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgWarning);
export default __webpack_public_path__ + "static/media/warning.4fa0f65970cd216f8aea0ba8ab9b2ed0.svg";
export { ForwardRef as ReactComponent };